import React from "react";
import { Box, Paper, Typography, Grid, Divider, IconButton } from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";

const ellipsisStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
};

const labelStyle = {
  fontWeight: 800,
  color: '#002045',
  fontSize: { xs: 14, sm: 16 },
};

const valueStyle = {
  color: '#002045',
  fontSize: { xs: 13, sm: 14 },
  ...ellipsisStyle,
};

const htmlvalueStyle = {
  color: '#002045',
  ...ellipsisStyle,
};

const CourseCard = ({ course, loading = false, onClick, onBookmarkClick }) => {
  if (!course) return null;
  const isBookmarked = course.isBookmarked;
  return (
    <Paper
      elevation={0}
      onClick={!loading ? onClick : undefined}
      sx={{
        backgroundColor: "#fafafa",
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        borderRadius: "16px",
        overflow: "hidden",
        opacity: loading ? 0.5 : 1,
        cursor: loading ? "default" : "pointer",
        p: { xs: 2, sm: 3 },
        minHeight: {
          xs: 120,   // mobile
          sm: 120,   // tablet
          md: 150,   // desktop
        },
        display: "flex",
        color: '#002045',
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: loading ? "none" : "0 8px 24px rgba(0,0,0,0.12)",
        },
      }}
    >
      {/* ---------- Top Line ---------- */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 1,
        }}

      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 0.5,
            alignItems: "center",
          }}
        >
          {course.degree_name && (
            <Typography sx={{ ...valueStyle, fontWeight: 600 }}>
              {course.degree_name || "-"}
            </Typography>
          )}

          {course.degree_name && course.course_name && (<Typography sx={{ color: '#002045', }}>|</Typography>)}

          {course.course_name && (
            <Typography sx={{ ...valueStyle, fontWeight: 600 }}>
              {course.course_name || "-"}
            </Typography>
          )}



          {course.course_name && course.university_name && (<Typography sx={{ color: '#002045', }}>|</Typography>)}

          {course.university_name && (
            <Typography sx={valueStyle}>
              {course.university_name}
            </Typography>
          )}
        </Box>

        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation(); // prevent card click
            onBookmarkClick?.(course);
          }}
          sx={{
            color: "#002045",
          }}
        >
          {isBookmarked ? (
            <BookmarkIcon sx={{ color: "#002045" }} />
          ) : (
            <BookmarkBorderIcon />
          )}

        </IconButton>
      </Box>

      <Divider sx={{ mt: 1, mb: 1, backgroundColor: "#ffffff" }} />

      {/* ---------- Bottom Grid ---------- */}
      <Box sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)", // mobile
          md: "repeat(4, 1fr)", // desktop
        },
        gap: 2,
      }}>

        {/* Course Language */}
        <Grid size={{ xs: 6, sm: 6, md: 6 }}>
          <Typography sx={labelStyle}>Course Language</Typography>
          <Typography sx={valueStyle}>
            {course.language_names || "-"}
          </Typography>
        </Grid>

        {/* Duration */}
        <Grid size={{ xs: 6, sm: 6, md: 6 }}>
          <Typography sx={labelStyle}>Duration</Typography>
          <Typography sx={valueStyle}>
            {course.duration_title || "-"}
          </Typography>
        </Grid>

        {/* Intake */}
        <Grid size={{ xs: 6, sm: 6, md: 6 }}>
          <Typography sx={labelStyle}>Intake</Typography>
          <Typography
            sx={htmlvalueStyle}
            dangerouslySetInnerHTML={{
              __html: course.start_of_study || "-"
            }}
          />
        </Grid>

        {/* Tuition Fees */}
        <Grid size={{ xs: 6, sm: 6, md: 6 }}>
          <Typography sx={labelStyle}>
            Tuition Fees (Per Semester)
          </Typography>
          <Typography sx={valueStyle}>
            {course.fees || "-"}
          </Typography>
        </Grid>

      </Box>
    </Paper>
  );
};

export default CourseCard;